import { gql } from '@apollo/client'

export const GET_CURRENT_USERINFO = gql`
  query getCurrentUserInfo {
    userinfo: copyrightUserInfo {
      avatarUrl
      nickname
      tradePwdStatus
      authStatus
      backgroundUrl
      blockChainAddress
      userRoleInfo {
        artist
        aiArtist
      }
      # vip标识
      memberDetail {
        hold
      }
      personalizedSignature
      inviteCode
      integralWalletBalance {
        availableBalance
        frozenBalance
        # 权益卡积分
        memberCardIntegralBalance
        # 总可用积分余额
        totalAvailableBalance
        # 魔法卡积分
        originCardBalance
      }
      base {
        uid
        mobile
      }
      userType # 区分机构用户｜个人用户
      whiteList {
        isArtworkAllowNoSellAllPower
      }
      social {
        fansCount
        followCount
        likesCount: squareLikesCount
        followStatus
        uid
      }
      authInfo {
        needMakeUp
        idCard
        realName
        areaCode
      }
      muzzleEndTime
      muzzleStatus
      memberDetail {
        hold
        endTime
      }
      # 是否是白名单用户（广场）
      isPlazaWhiteListUser: whitelistStatus
    }
    aiEquity: accountModule {
      userMemberCardList {
        cardType
        name
      }
    }
    pictureGraph {
      aiCreateArtworkOptionMenu {
        inWhiteList
      }
    }
  }
`

export const GET_DEFAULT_AVATARS = gql`
  query getDefaultAvatars {
    copyrightUserAvatars {
      systemUrl {
        id
        avatarUrl
      }
    }
  }
`

export const GET_USERINFO = gql`
  query getUserInfo($uid: Long) {
    userinfo: copyrightUserInfo(uid: $uid) {
      backgroundUrl
      avatarUrl
      nickname
      personalizedSignature
      userRoleInfo {
        artist
        aiArtist
      }
      userType
      social {
        fansCount
        followCount
        likesCount: squareLikesCount
        followStatus
        uid
        # 作画次数
        aiPictureCount
        # 发布创作
        squareCount
        # 被同款数
        aiSameStyleCount

        # 同款榜
        aiSameStyleRank
        # 作画榜
        aiPictureRank
        # 粉丝榜
        fansRank
      }
      memberDetail {
        hold
      }
      companyAuthInfo {
        id
      }
      memberDetail {
        hold
      }
      medals {
        url
        name
      }
    }
  }
`

export const GET_REAL_NAME_INFO = gql`
  query getRealNameInfo {
    copyrightAuthInfo {
      idCard
      realName
    }
  }
`

export const REAL_NAME_AUTH = gql`
  mutation realNameAuth($param: RealNameAuthParam!) {
    status: realNameAuth(param: $param)
  }
`

export const REAL_NAME_AUTH_COMPLETION = gql`
  mutation realNmaeAuthCompletion($param: RealNameAuthMakeUpParam!) {
    status: realNameAuthMakeUp(param: $param)
  }
`

export const UPDATE_USER_BASE_INFO = gql`
  mutation updateUserBaseInfo($param: MyCopyrightInfoParam!) {
    status: updateMyCopyrightInfo(param: $param)
  }
`

export const GET_AUTH_USER_INFO = gql`
  query getAuthUserInfo {
    copyrightAuthInfoPlaintext {
      idCard
      realName
      idCardFrontUrl
      idCardBackUrl
    }
  }
`

/** 我拥有的所有权作品列表 */
export const GET_OWNED_PRODUCT_LIST = gql`
  query getOwnedProductList($first: Int, $offset: Int, $userId: Int) {
    itemModule {
      productList: ownerArtworkPage(
        page: { first: $first, offset: $offset }
        userId: $userId
      ) {
        edges {
          node {
            id
            artworkUrl
          }
        }
      }
    }
  }
`

/** 统计用户信息设备信息 */
export const USER_DEVICE_INFO = gql`
  mutation userDeviceInfo($input: DeviceInfoInput, $cid: String!) {
    status: uploadCid(input: $input, cid: $cid)
  }
`
